<template>
  <div class="quantity flex actions">
    <div class="quantity-wrap large">
      <button
        @click="updateQuantity('-')"
        :disabled="payload.qty <= 1"
      >
        <span class="icon-minus2"></span>
      </button>
      <input
        type="text"
        v-model="payload.qty"
        class="flex-center"
      >
      <button
        @click="updateQuantity('+')"
      >
        <span class="icon-plus2"></span>
      </button>
    </div>

    <div class="buttons">
      <a
        class="button"
        :disabled="disableButton"
        @click="addToCart()"
      >
        Add to Cart
      </a>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      product: Object
    },
    
    data () {
      return {
        disableButton: false,
        showFastOrder: false,
        payload: {
          id: this.product.id,
          qty: 1,
          updateQty: true
        }
      }
    },
    
    mounted () {
      this.payload.product_id = this.id
    },
    
    methods: {
      
      updateQuantity (symbol) {
        if (symbol == '+') {
          this.payload.qty++
        } else {
          this.payload.qty--
        }
      },

      addToCart () {
        this.$store.commit('setLoading', true)
        let qty = parseInt(this.payload.qty)

        if (qty < 1) {
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>Product quantity should not be less than 1</p>'
          })

          return
        }

        this.disableButton = true
        
        window.axios.post('/api/cart', this.payload)
          .then((response) => {
            this.$store.commit('setLoading', false)
            this.disableButton = false

            this.$store.commit('setCart', response.data)

            this.$store.commit('setToastMessage', {
              open: true,
              type: 'success',
              message: 'Product has been added to cart.'
            })
          })
          .catch((error) => {
            this.$store.commit('setLoading', false)

            this.$store.commit('setToastMessage', {
              open: true,
              type: 'fail',
              message: error.response.data.message
            })
            this.disableButton = false
          })
      }
      
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/AddToCart.vue